import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[2]}px;
      padding-top: ${theme.spacing[6]}px;
    `;
  }}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1] - 1}px;
`;
